import { Table } from "react-bootstrap";
import Tooltip from "../helpers/Tooltip";
import Img from "../../../../icons/ErrorIcon.svg";
import { isAllowDashedSpecialCharacters, isAlphanumericAllSpecialCharacters } from "../../../../functions/validations";




export const WPQPage3Table3observation = ({
  name3,
  value3,
  status2,
  readOnly,
  message2,
  setError,
  handleChangetestarray,
  maxLength3,
  valueNotes,
}) => {

  let imgerror2 = status2 && (
    <Tooltip content={message2}>
      <img src={Img} alt="Error" className="ms-1" />
    </Tooltip>
  );

  return (
    <Table
      className="text-left "

    >
      <thead>
        <tr className="border thead-color ">
          <th className="thickness_title "> {imgerror2} &nbsp; Observation</th>
          <th className="thickness_title "></th>
        </tr>
      </thead>

      <tbody>
        <tr className={"border "}>
          <td className="WpsInput-md  " style={{ paddingLeft: "2%" }}>
            <textarea
              style={{
                width: "505px",
                height: "139px",
                outlineColor: "black",
                resize: "none",
              }}
              type="text"
              id={name3}
              name={name3}
              placeholder=" "
              maxLength={maxLength3 ? maxLength3 : 500}
              readOnly={readOnly}
              // className={error.WPQ_WelderName.status ? "err-input" : ""}
              value={value3 ? value3 : valueNotes}
              onChange={handleChangetestarray}
              onInput={(e) => {
                let error = isAlphanumericAllSpecialCharacters(e.target.value);
                setError((prevState) => ({
                  ...prevState,
                  [name3]: error,
                }));
              }}
            />
          </td>
          <td className="WpsInput-md  " style={{ paddingLeft: "2%" }}></td>
        </tr>
      </tbody>
    </Table>
  );
};

export const PQR_Page3_Table3 = ({
  array,
  name1,
  name2,
  name3,
  table,
  status,
  status1,
  status2,
  readOnly,
  message,
  message1,
  message2,
  setError,
  handleChangetestarray,
  maxLength1,
  maxLength2,
  maxLength3,
  allowlistfunction,
  title1,
  title2,
  title3,
}) => {


  let imgerror = status && (
    <Tooltip content={message}>
      <img src={Img} alt="Error" className="ms-1" />
    </Tooltip>
  );
  let imgerror1 = status1 && (
    <Tooltip content={message1}>
      <img src={Img} alt="Error" className="ms-1" />
    </Tooltip>
  );

  let imgerror2 = status2 && (
    <Tooltip content={message2}>
      <img src={Img} alt="Error" className="ms-1" />
    </Tooltip>
  );

  return (
    <Table className="text-left tablewidth">
      <thead>
        <tr className="border thead-color ">
          <th className="thickness_title " style={{ width: "30%" }}>
            {imgerror} &nbsp; {title1}
          </th>
          <th className="thickness_title " style={{ width: "30%" }}>
            {" "}
            {imgerror1} &nbsp; {title2}
          </th>
          <th className="thickness_title " style={{ width: "30%" }}>
            {" "}
            {imgerror2} &nbsp; {title3}
          </th>
        </tr>
      </thead>

      <tbody>
        {array &&
          array.map((item, i) => {
            return (
              <tr key={item.id || `row-${i}`} className={array[i]?.error ? "border error" : "border "}>
                <td className="WpsInput-md ">
                  {array[i]?.error && (
                    <Tooltip content={array[i]?.errormessage}>
                      <img
                        src={Img}
                        alt="Error"
                        className="ms-1"
                        style={{ position: "relative", right: "10px" }}
                      />
                    </Tooltip>
                  )}

                  <input
                    style={{ width: "245px" }}
                    type="text"
                    id={name1}
                    name={name1}
                    placeholder=" "
                    maxLength={maxLength1 ? maxLength1 : 40}
                    readOnly={readOnly}
                    value={item[name1]}
                    onChange={(e) =>
                      handleChangetestarray(i, name1, table, e.target.value)
                    }
                    onInput={(e) => {
                      let error = allowlistfunction ? allowlistfunction(e.target.value) : isAlphanumericAllSpecialCharacters(
                        e.target.value
                      );
                      setError((prevState) => ({
                        ...prevState,
                        [name1]: error,
                      }));
                    }}
                  />
                </td>
                <td className="WpsInput-md " style={{ paddingLeft: "2%" }}>
                  <input
                    style={{ width: "245px" }}
                    type="text"
                    id={name2}
                    name={name2}
                    placeholder=" "
                    maxLength={maxLength2 ? maxLength2 : 40}
                    readOnly={readOnly}
                    value={item[name2]}
                    onChange={(e) =>
                      handleChangetestarray(i, name2, table, e.target.value)
                    }
                    onInput={(e) => {
                      let error = allowlistfunction ? allowlistfunction(e.target.value) : isAlphanumericAllSpecialCharacters(
                        e.target.value
                      );
                      setError((prevState) => ({
                        ...prevState,
                        [name2]: error,
                      }));
                    }}
                  />
                </td>
                <td className="WpsInput-md " style={{ paddingLeft: "2%" }}>
                  <input
                    style={{ width: "245px" }}
                    type="text"
                    id={name3}
                    name={name3}
                    placeholder=" "
                    maxLength={maxLength3 ? maxLength3 : 40}
                    readOnly={readOnly}
                    value={item[name3]}
                    onChange={(e) =>
                      handleChangetestarray(i, name3, table, e.target.value)
                    }
                    onInput={(e) => {
                      let error = allowlistfunction ? allowlistfunction(e.target.value) : isAlphanumericAllSpecialCharacters(
                        e.target.value
                      );
                      setError((prevState) => ({
                        ...prevState,
                        [name3]: error,
                      }));
                    }}
                  />
                </td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export const PQRPage3TableColumnN = ({
  columns,
  cols,
  array,
  name,
  status,
  readOnly,
  message,
  setError,
  handleChangetestarray,
  maxLength,
  allowlistfunction,
  title,
  disabled,
  width,
  session,
  numberofrowsdisabled,
  variant,
  // New props for multi-level headers
  multiLevelHeaders = false,
  mainHeaders = [],
  subHeaders = [],
  headerSpans = [] // Array of objects: [{rowSpan: 2, colSpan: 1}, {rowSpan: 1, colSpan: 2}, ...]
}) => {
  let imgerr = [];

  let names = name;
  let headerRow = [];
  let subHeaderRow = [];

  for (let i = 0; i <= columns; i++) {

    let imgerror = status[i] && (

      <Tooltip content={message[i]} variant={variant}>
        <img src={Img} alt="Error" className="ms-1" />
      </Tooltip>
    );
    imgerr.push(imgerror);
  }

  let headerclass = "thickness_title ";
  let tableclass = "text-left tablewidth";
  if (session == "WPQ") {
    headerclass = "thickness_title border";
    tableclass = "text-center tablewidth";
  }

  // Build headers based on multiLevelHeaders flag
  if (multiLevelHeaders && mainHeaders.length > 0) {
    // Build main header row
    mainHeaders.forEach((header, i) => {
      const span = headerSpans[i] || { rowSpan: 1, colSpan: 1 };
      const columnWidth = width && width[i] ? `${width[i]}px` : "auto";
      headerRow.push(
        <th 
          key={`main-${i}`}
          className={headerclass} 
          style={{ minWidth: columnWidth, verticalAlign: 'middle', textAlign: 'center' }}
          rowSpan={span.rowSpan}
          colSpan={span.colSpan}
        >
          {imgerr[i]} {header}
        </th>
      );
    });

    // Build sub header row if exists
    if (subHeaders.length > 0) {
      subHeaders.forEach((header, i) => {
        let subColStartIndex = 0;
        for (let h = 0; h < headerSpans.length; h++) {
          if (headerSpans[h] && headerSpans[h].rowSpan === 1 && headerSpans[h].colSpan > 1) {
            subColStartIndex = h;
            break;
          }
        }
        const subColumnWidth = width && width[subColStartIndex + i] ? `${width[subColStartIndex + i]}px` : "auto";
        subHeaderRow.push(
          <th key={`sub-${i}`} className={headerclass} style={{ minWidth: subColumnWidth, textAlign: 'center' }}>
            {header}
          </th>
        );
      });
    }
  } else {
    // Original single-level headers
    title.map((item, i) => {
      headerRow.push(
        <th key={`single-${i}`} className={headerclass} style={{ width: "25%" }}>
          {imgerr[i]} {title[i]}
        </th>
      );
    });
  }

  function createRow(isdisabled, item, errormsg, row) {
    let ObjCols = [];
    let position = 1;
    for (let cols = 0; cols < columns; cols++) {
      let key = names != undefined ? names[cols] : "";
      ObjCols.push(
        <td className="WpsInput-md " key={`${key}-${cols}-${row}`}>
          {errormsg && cols == 0 && (
            <Tooltip content={errormsg} variant={variant}>
              <img
                src={Img}
                alt="Error"
                className="ms-1"
                style={{ position: "relative", right: "10px" }}
              />
            </Tooltip>
          )}

          <input
            style={{ width: `${width[cols] - 10}px`, minWidth: '80px' }}
            id={key}
            name={key}
            placeholder=" "
            maxLength={maxLength[cols] ? maxLength[cols] : 40}
            readOnly={readOnly}
            value={item[key]}
            disabled={isdisabled}
            onChange={(e) => {
              handleChangetestarray(row, key, e.target.value);
            }}
            onInput={(e) => {
              let error = allowlistfunction ? allowlistfunction(e.target.value):isAllowDashedSpecialCharacters(e.target.value);
              setError((prevState) => ({
                ...prevState,
                [key]: error,
              }));
            }}
          />
        </td>
      );
      position = position + 1;
    }

    return <>{ObjCols}</>;
  }



  return (
    <Table className={tableclass}>
      <thead>
        <tr className="border thead-color ">
          {headerRow &&
            headerRow.map((head, index) => {
              return head;
            })}
        </tr>
        {multiLevelHeaders && subHeaderRow.length > 0 && (
          <tr className="border thead-color ">
            {subHeaderRow &&
              subHeaderRow.map((head, index) => {
                return head;
              })}
          </tr>
        )}
      </thead>

      <tbody>
        {array &&
          array.map((item, i) => {
            let isdisabled = false;
            if (i >= numberofrowsdisabled) {
              isdisabled = disabled
            }
            return (
              <tr key={item.id || `row-${i}`} className={array[i]?.error ? "border error" : "border "}>
                {createRow(isdisabled, item, array[i]?.errormessage, i)}
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export const PQRPage3TableColumnNindex = ({
  columns,
  cols,

  array,
  name,
  status,

  readOnly,
  table,
  index,
  message,

  setError,
  handleChangetestarray,
  maxLength,
  allowlistfunction,
  title,
  disabled,
  numberofrowsdisabled,
}) => {
  let imgerr = [];
  let names = name;
  let headerRow = [];

  for (let i = 0; i <= columns; i++) {
    let imgerror = status[i] && (
      <Tooltip content={message[i]}>
        <img src={Img} alt="Error" className="ms-1" />
      </Tooltip>
    );
    imgerr.push(imgerror);
  }

  title.map((item, i) => {
    headerRow.push(
      <th className="thickness_title " style={{ width: "25%" }}>
        {imgerr[i]} &nbsp; {title[i]}
      </th>
    );
  });

  function createRow(isdisabled, item, errormsg, row) {
    let ObjCols = [];
    for (let cols = 0; cols < columns; cols++) {
      let key = names != undefined ? names[cols] : "";
      ObjCols.push(
        <td className="WpsInput-md " key={`${key}-${cols}-${row}-${index}`}>
          {errormsg && cols == 0 && (
            <Tooltip content={errormsg}>
              <img
                src={Img}
                alt="Error"
                className="ms-1"
                style={{ position: "relative", right: "10px" }}
              />
            </Tooltip>
          )}

          <input
            type="text"
            id={key}
            name={key}
            placeholder=" "
            maxLength={maxLength[cols] ? maxLength[cols] : 40}
            readOnly={readOnly}
            index={index}
            value={item[key]}
            disabled={isdisabled}
            onChange={(e) => {
              handleChangetestarray(row, key, table, e.target.value);
            }}
            onInput={(e) => {
              let error = allowlistfunction ? allowlistfunction(e.target.value) : isAlphanumericAllSpecialCharacters(e.target.value);
              let key1 = key + index;
              setError((prevState) => ({
                ...prevState,
                [key1]: error,
              }));
            }}
          />
        </td>
      );
    }

    return <>{ObjCols}</>;
  }



  return (
    <Table className="text-center tablewidth">
      <thead>
        <tr className="border thead-color ">
          {headerRow &&
            headerRow.map((head, id) => {
              return head;
            })}
        </tr>
      </thead>

      <tbody>
        {array &&
          array.map((item, i) => {
            let isdisabled = false;
            if (i >= numberofrowsdisabled) {
              isdisabled = disabled
            }
            return (
              <tr key={item.id || `row-${i}`} className={array[i]?.error ? "border error" : "border "}>
                {createRow(isdisabled, item, array[i]?.errormessage, i)}
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export const PQRToughnessTestTable = ({
  array,
  disabled,
  handleChangetestarray,
  setError,
  allowlistfunction,
  specimenSizeValue,
  onSpecimenSizeChange,
  specimenSizeDisabled,
}) => {
  const columns = [
    { key: "PQR_TT_SpecimenNo", maxLength: 45, width: 130 },
    { key: "PQR_TT_WeldingProcess", maxLength: 5, width: 90 },
    { key: "PQR_TT_NotchLocation", maxLength: 5, width: 90 },
    { key: "PQR_TT_TestTemp", maxLength: 5, width: 90 },
    { key: "PQR_TT_ImpactValues", maxLength: 17, width: 120 },
    { key: "PQR_TT_Avg", maxLength: 5, width: 80 },
    { key: "PQR_TT_LateralExpansion", maxLength: 14, width: 120 },
    { key: "PQR_TT_Shear", maxLength: 14, width: 120 },
  ];

  return (
    <Table className="text-left tablewidth">
      <thead>
        <tr className="border thead-color ">
          <th className="thickness_title " colSpan={2} style={{ textAlign: "center" }}>Impact Test</th>
          <th className="thickness_title " colSpan={2} style={{ textAlign: "center" }}>Charpy V Notch</th>
          <th className="thickness_title " style={{ textAlign: "center" }}>Specimen Size in mm</th>
          <th className="thickness_title " colSpan={3} style={{ textAlign: "center" }}>
            <input
              className="form-control form-control-sm d-inline-block"
              style={{ width: "90%" }}
              type="text"
              placeholder=" "
              maxLength={15}
              value={specimenSizeValue || ""}
              disabled={specimenSizeDisabled}
              onChange={onSpecimenSizeChange}
              onInput={(e) => {
                if (allowlistfunction) {
                  let error = allowlistfunction(e.target.value);
                  setError((prev) => ({ ...prev, PQR_TT_SpecimenSize_Dimension: error }));
                }
              }}
            />
          </th>
        </tr>
        <tr className="border thead-color ">
          <th className="thickness_title " rowSpan={2} style={{ verticalAlign: "middle", minWidth: `${columns[0].width}px` }}>Location of Specimen</th>
          <th className="thickness_title " rowSpan={2} style={{ verticalAlign: "middle", minWidth: `${columns[1].width}px` }}>Welding Process</th>
          <th className="thickness_title " rowSpan={2} style={{ verticalAlign: "middle", minWidth: `${columns[2].width}px` }}>Notch Location</th>
          <th className="thickness_title " rowSpan={2} style={{ verticalAlign: "middle", minWidth: `${columns[3].width}px` }}>Test Temp. °C</th>
          <th className="thickness_title " colSpan={4} style={{ textAlign: "center" }}>Impact Values</th>
        </tr>
        <tr className="border thead-color ">
          <th className="thickness_title " style={{ minWidth: `${columns[4].width}px` }}>Impact Value (J)</th>
          <th className="thickness_title " style={{ minWidth: `${columns[5].width}px` }}>Avg. (J)</th>
          <th className="thickness_title " style={{ minWidth: `${columns[6].width}px` }}>Lateral Expansion (mm)</th>
          <th className="thickness_title " style={{ minWidth: `${columns[7].width}px` }}>% Shear Fracture</th>
        </tr>
      </thead>
      <tbody>
        {array &&
          array.map((item, rowIdx) => {
            return (
              <tr key={item.id || `row-${rowIdx}`} className={item?.error ? "border error" : "border "}>
                {columns.map((col) => (
                  <td className="WpsInput-md " key={`${col.key}-${rowIdx}`}>
                    {item?.error && col.key === columns[0].key && (
                      <Tooltip content={item?.errormessage}>
                        <img
                          src={Img}
                          alt="Error"
                          className="ms-1"
                          style={{ position: "relative", right: "10px" }}
                        />
                      </Tooltip>
                    )}
                    <input
                      style={{ width: `${col.width - 10}px`, minWidth: '80px' }}
                      id={col.key}
                      name={col.key}
                      placeholder=" "
                      maxLength={col.maxLength}
                      value={item[col.key]}
                      disabled={disabled}
                      onChange={(e) => {
                        handleChangetestarray(rowIdx, col.key, e.target.value);
                      }}
                      onInput={(e) => {
                        let error = allowlistfunction ? allowlistfunction(e.target.value) : isAllowDashedSpecialCharacters(e.target.value);
                        setError((prevState) => ({
                          ...prevState,
                          [col.key]: error,
                        }));
                      }}
                    />
                  </td>
                ))}
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};